(function ($) {
	'use strict';

	var attributionStorageKey = 'dd_anfragen_attribution_v1';
	var attributionLifetime = 90 * 24 * 60 * 60 * 1000;
	var attributionKeys = [
		'utm_source',
		'utm_medium',
		'utm_campaign',
		'utm_term',
		'utm_content',
		'gclid',
		'fbclid'
	];

	function getStoredAttribution() {
		try {
			var stored = window.localStorage.getItem(attributionStorageKey);
			var attribution = stored ? JSON.parse(stored) : null;

			if (!attribution || !attribution.expiresAt || attribution.expiresAt < Date.now()) {
				window.localStorage.removeItem(attributionStorageKey);
				return null;
			}

			return attribution;
		} catch (error) {
			return null;
		}
	}

	function storeAttribution(attribution) {
		try {
			window.localStorage.setItem(attributionStorageKey, JSON.stringify(attribution));
		} catch (error) {
			// Attribution must never prevent the form from working.
		}
	}

	function getQueryParameter(parameterName) {
		var parameters = new window.URLSearchParams(window.location.search);
		return parameters.get(parameterName) || '';
	}

	function getCurrentTouch() {
		var touch = {
			landing_page: window.location.href,
			referrer: document.referrer || '',
			captured_at: new Date().toISOString()
		};
		var hasCampaignData = false;

		$.each(attributionKeys, function (_, key) {
			var value = getQueryParameter(key).substring(0, 255);
			touch[key] = value;
			hasCampaignData = hasCampaignData || value !== '';
		});

		touch.has_campaign_data = hasCampaignData;
		return touch;
	}

	function captureAttribution() {
		var stored = getStoredAttribution();
		var currentTouch = getCurrentTouch();

		if (!stored) {
			stored = {
				first: currentTouch,
				last: currentTouch,
				expiresAt: Date.now() + attributionLifetime
			};
			storeAttribution(stored);
			return stored;
		}

		if (currentTouch.has_campaign_data) {
			stored.last = currentTouch;
			stored.expiresAt = Date.now() + attributionLifetime;
			storeAttribution(stored);
		}

		return stored;
	}

	function populateAttributionFields($form, attribution) {
		if (!attribution) {
			return;
		}

		$.each(['first', 'last'], function (_, touchType) {
			var touch = attribution[touchType] || {};
			var fields = attributionKeys.concat(['landing_page', 'referrer', 'captured_at']);

			$.each(fields, function (__, fieldName) {
				$('<input>', {
					type: 'hidden',
					name: touchType + '_' + fieldName,
					value: touch[fieldName] || ''
				}).appendTo($form);
			});
		});
	}

	$(function () {
		var attribution = captureAttribution();

		$('[data-anfragen-flow]').each(function () {
			var $flow = $(this);
			var $form = $flow.find('[data-anfragen-form]');
			var $steps = $form.find('[data-step]');
			var $success = $form.find('[data-success-state]');
			var $indicator = $flow.find('[data-step-indicator]');
			var $percent = $flow.find('[data-step-percent]');
			var $progress = $flow.find('[data-step-progress]');
			var $title = $flow.find('[data-current-step-title]');
			var $header = $flow.find('.anfragen-flow-header');
			var $next = $form.find('[data-step-next]');
			var $submit = $form.find('[data-step-submit]');
			var $back = $form.find('[data-step-back]');
			var $navigation = $form.find('[data-form-navigation]');
			var $error = $form.find('[data-form-error]');
			var ajaxUrl = $flow.data('ajax-url');
			var nonce = $flow.data('nonce');
			var totalSteps = parseInt($flow.data('total-steps'), 10) || $steps.length;
			var currentStep = 0;
			var submitLabel = $submit.html();

			populateAttributionFields($form, attribution);

			function clearError() {
				$error.prop('hidden', true).text('');
			}

			function showError(message) {
				$error.text(message).prop('hidden', false);
			}

			function clearFieldError($field) {
				$field.removeClass('is-invalid');
				$field.find('input').attr('aria-invalid', 'false');
				$field.find('[data-field-error]').prop('hidden', true);
			}

			function fieldErrorMessage(field) {
				if (field.type === 'checkbox') {
					return 'Bitte bestätigen Sie die Datenschutzerklärung.';
				}

				if (field.name === 'postcode' && field.validity.patternMismatch) {
					return 'Bitte geben Sie eine gültige fünfstellige Postleitzahl ein.';
				}

				if (field.validity.typeMismatch) {
					return 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
				}

				return 'Bitte füllen Sie dieses Feld aus.';
			}

			function showFieldError($input) {
				var $field = $input.closest('.anfragen-field');
				$field.addClass('is-invalid');
				$input.attr('aria-invalid', 'true');
				$field.find('[data-field-error]').first().text(fieldErrorMessage($input.get(0))).prop('hidden', false);
			}

			function validateStep() {
				var $current = $steps.eq(currentStep);
				var type = $current.data('step-type');
				var valid = true;

				clearError();

				if (type === 'postcode' || type === 'contact') {
					$current.find('.anfragen-field').each(function () {
						clearFieldError($(this));
					});

					$current.find('input[required]').each(function () {
						if (!this.checkValidity()) {
							valid = false;
							showFieldError($(this));
						}
					});

					return valid;
				}

				if (!$current.find('input[type="radio"]:checked').length) {
					showError('Bitte wählen Sie eine Option aus, um fortzufahren.');
					return false;
				}

				return true;
			}

			function updateChrome() {
				var $current = $steps.eq(currentStep);
				var isLast = currentStep === $steps.length - 1;
				var isChoiceStep = $current.data('step-type') === 'choices';
				var progress = totalSteps > 1 ? Math.round((currentStep / (totalSteps - 1)) * 100) : 100;

				$indicator.text('Schritt ' + (currentStep + 1) + ' von ' + totalSteps);
				$percent.text(progress + '%');
				$progress.css('width', progress + '%');
				$title.text($current.data('step-heading') || '');
				$back.prop('disabled', currentStep === 0);
				$next.prop('hidden', isLast || isChoiceStep);
				$submit.prop('hidden', !isLast);
			}

			function activateStep(index, focusHeading) {
				if (index < 0 || index >= $steps.length) {
					return;
				}

				currentStep = index;
				$steps.each(function (stepIndex) {
					var isActive = stepIndex === currentStep;
					$(this).toggleClass('is-active', isActive).toggleClass('is-hidden', !isActive).attr('aria-hidden', isActive ? 'false' : 'true');
				});

				clearError();
				updateChrome();
				$steps.eq(currentStep).addClass('is-entering');
				window.setTimeout(function () {
					$steps.eq(currentStep).removeClass('is-entering');
				}, 360);

				if (focusHeading) {
					$title.trigger('focus');
				}
			}

			function payload() {
				var data = { action: 'dd_submit_anfragen_form', nonce: nonce };

				$.each($form.serializeArray(), function (_, field) {
					data[field.name] = field.value;
				});

				return data;
			}

			function showSuccess() {
				$steps.addClass('is-hidden').removeClass('is-active').attr('aria-hidden', 'true');
				$success.removeClass('is-hidden').attr('aria-hidden', 'false');
				$header.prop('hidden', true);
				$navigation.addClass('is-hidden');
			}

			$form.on('input change', 'input', function () {
				var $field = $(this).closest('.anfragen-field');
				clearError();

				if ($field.hasClass('is-invalid') && this.checkValidity()) {
					clearFieldError($field);
				}
			});

			$form.on('change', '.anfragen-step[data-step-type="choices"] input[type="radio"]', function () {
				if (!validateStep()) {
					return;
				}

				window.setTimeout(function () {
					activateStep(currentStep + 1, true);
				}, 180);
			});

			$next.on('click', function () {
				if (validateStep()) {
					activateStep(currentStep + 1, true);
				}
			});

			$back.on('click', function () {
				activateStep(currentStep - 1, true);
			});

			$form.on('submit', function (event) {
				event.preventDefault();

				if (!validateStep()) {
					return;
				}

				$submit.prop('disabled', true).text('Wird gesendet …');
				clearError();

				$.post(ajaxUrl, payload())
					.done(function (response) {
						if (response && response.success) {
							showSuccess();
							return;
						}

						showError(response && response.data && response.data.message ? response.data.message : 'Beim Senden ist ein Fehler aufgetreten.');
					})
					.fail(function (xhr) {
						var response = xhr.responseJSON;
						showError(response && response.data && response.data.message ? response.data.message : 'Die Anfrage konnte gerade nicht gesendet werden. Bitte versuchen Sie es erneut.');
					})
					.always(function () {
						$submit.prop('disabled', false).html(submitLabel);
					});
			});

			activateStep(0, false);
		});
	});
})(jQuery);
